module.exports = __webpack_public_path__ + "static/media/0328_IMG_LE_SOL_MEGALITH_MEGABROWN.c4a3d905.png";